<script>
import { BInputGroupAddon } from "bootstrap-vue";

export default {
  extends: BInputGroupAddon
};
</script>